export default __webpack_public_path__ + "src/images/stake.svg";